import { Box, Typography } from "@mui/material";
import { ROLE } from "pages/subtitles/components/constants";
import { useTranslation } from "react-i18next";
import { ReactComponent as IconAdd } from "assets/svg/IconAdd.svg";
import UserRoom from "./UserRoom";


export default function ListUserRoom({dataParticipants, setChangeDataParticipant, displayCloseIcon, handleOpenModalShareSubtitles, hideAddButton, isChangePeriod}){
    const {t} = useTranslation();

    return (
        <Box sx={{height: '100%', overflowY: 'auto'}}>
            <Box sx={{display: 'flex', flexWrap: 'wrap', paddingBottom: dataParticipants.length === 0 ? '0px' : '10px', alignItems: 'center'}}>
                {dataParticipants?.map((dataParticipant, index) => {
                    return (
                        <UserRoom 
                            OperatorRole={(dataParticipant.role === ROLE.OWNER || dataParticipant.role === ROLE.HOST || dataParticipant.role === ROLE.CO_HOST) ? true : false } 
                            dataParticipant={dataParticipant} 
                            index={index} 
                            setChangeDataParticipant={setChangeDataParticipant}
                            displayCloseIcon={displayCloseIcon}
                            isChangePeriod={isChangePeriod}
                        />
                    )
                })}
                {
                    hideAddButton || isChangePeriod
                    ?
                    (
                        <Typography sx={{ marginLeft: '10px', fontSize: '15px', color: 'transparent'}}>
                            {t('addPeople')}
                        </Typography>
                    )
                    : 
                    (
                        dataParticipants.length !== 0
                        ?
                        <IconAdd style={{cursor: 'pointer', paddingTop: '10px', width: '50px', height: '50px'}} onClick={handleOpenModalShareSubtitles}/>
                        :
                        <Typography sx={{ marginLeft: '10px', fontSize: '15px', color: theme => theme.palette.text.secondary }}>
                            {t('addPeople')}
                        </Typography>
                    )
                }
                
            </Box>
        </Box>
    )
}